import React, { useState } from 'react';
import { Icons } from './Icons';

const IdChip = ({ label, value, full = false }) => {
	const [copied, setCopied] = useState(false);

	if (!value) return null;

	const handleCopy = async () => {
		let ok = false;

		if (navigator.clipboard && window.isSecureContext) {
			try {
				await navigator.clipboard.writeText(value);
				ok = true;
			}
			catch (e) {
				ok = false;
			}
		}

		if (!ok) {
			const ta = document.createElement('textarea');
			ta.value = value;
			ta.setAttribute('readonly', '');
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			ta.style.left = '-9999px';
			document.body.appendChild(ta);
			ta.focus();
			ta.select();
			try {
				ok = document.execCommand('copy');
			}
			catch (e) {
				ok = false;
			}
			document.body.removeChild(ta);
		}

		if (ok) {
			setCopied(true);
			setTimeout(() => setCopied(false), 1500);
		}
	};

	const display = full || value.length <= 18
		? value
		: `${value.slice(0, 8)}…${value.slice(-6)}`;

	return (
		<button
			type='button'
			className={`pn-id-chip ${copied ? 'copied' : ''}`}
			onClick={handleCopy}
			title='Copy'
		>
			{label && <span className='pn-id-chip-label'>{label}</span>}
			<span>{display}</span>
			{copied ? <Icons.check /> : <Icons.copy />}
		</button>
	);
};

export default IdChip;
